var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.858 6.733a1 1 0 00-1.433.004l-.065.067a1 1 0 00.003 1.396l2.698 2.756L4 10.969a1 1 0 00-.999 1.001v.122a1 1 0 001.001.999l13.023-.014-2.645 2.727a1 1 0 00.004 1.396l.065.067a1 1 0 001.433-.004L21 11.986l-5.142-5.253z",
    fill: "#9CA6AD"
  })));
};

export default SvgArrowRight;